<!-- 文件的树形结构 -->
<template>
  <div class="PublicFileTree">
    <div class="FileTreeTop">
      <!-- 搜索框 -->
      <div
        class="searchInput"
        >
        <el-input
          v-model="searchFileParam.condition"
          :placeholder="$t('lang.select')"
          class="SearchInput"
          @input="getSearchFile"
          ></el-input>
        <i
          class="el-icon-arrow-up"
          :class="showFileAll?'icon-arrow-reverse':'icon-arrow-caret'"
          @click.stop="showFile"></i>
      </div>
    </div>
    <!-- 下面的文件树 -->
    <div class="FileTreeScroll" v-if="showFileAll||show" >
      <div class="draggable_box">
        <div
          class="FileTree"
          v-if="showFileAll">
          <el-tree
            :props="props"
            lazy
            :load="loadNode"
            @node-click="getCurrentNode"
            :key="1"
            empty-text="No Data">
            <div
              class="TreeWrap"
              slot-scope="{ node, data }"
              @click="selectFile(node)"
              >
              <div v-if="!data.noData">
                <div
                  class="folderItem"
                  v-if="!data.directory">
                  <p class="fileTitle" :title="node.label">
                    {{ node.label }} {{ data.mediaCount ? " (" + data.mediaCount + ")" : "" }}
                  </p>
                </div>
                <div
                  class="draggable_item draggableFile"
                  draggable="true"
                  :data-device="JSON.stringify(data)"
                  v-else>
                  <p class="fileTitle" :title="TitleAndUpdate(node)">{{ node.label }}</p>
                   <div class="FileTime">
                      {{ formatSeconds(data.videoTimes,data.name) }}
                    </div>
                </div>
              </div>
              <div
                class="noData"
                v-else>
                {{ $t('lang.noData') }}
              </div>
            </div>
          </el-tree>
        </div>
        <div
          class="searchFileTree"
          v-if="show"
          >
          <el-tree
            :data="searchFileList"
            :props="searchListProps"
            :default-expand-all="true"
            @node-click="getCurrentNode"
            :key="2">
            <div
              class="TreeWrap"
              slot-scope="{ node, data }"
              @click="selectFile(node)">
              <div>
                <div
                  class="folderItem"
                  v-if="!data.directory">
                  <p class="fileTitle" :title="node.label">{{ node.label }}</p>
                </div>
                <div
                  class="draggable_item draggableFile"
                  draggable="true"
                  :data-device="JSON.stringify(data)"
                  v-else>
                  <p class="fileTitle" :title="TitleAndUpdate(node)">{{ node.label }}</p>
                  <div class="FileTime">
                      {{ formatSeconds(data.videoTimes,data.name) }}
                    </div>
                </div>
              </div>
            </div>
          </el-tree>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import toTips from '@/assets/js/toTipsObj'
import Bus from '@/assets/js/vueBus.js'
import Outil from '@/assets/js/utils.js'
import { mapState } from 'vuex'
import { searchIframe } from '@/assets/js/TVUSearch'
import { componentsAnalyze, scheduleAnalyze, playoutAnalyze } from '../../assets/js/googleAnalyze/playout.js'
export default {
  props: {
    // 刷新节点
    renderNode: {
      type: Number,
      default: 0
    },
    SelectValue: {
      type: Object,
      default: () => ({
        fileId: '',
        fileName: ''
      })
    }
  },
  computed: mapState({
    State: (state) => state,
    CloneDisabled: (state) => state.playout.CloneDisabled
  }),
  data () {
    return {
      RefreshSwitch: true,
      // true文件false搜索文件
      FileTree: true,
      // bucket
      bucket: '',
      // 列表配置
      props: {
        label: 'name',
        children: 'childNodes',
        isLeaf: 'directory'
      },
      // 第一级id
      NodeHeadId: 0,
      // 存储所有点开的父级节点
      parentMap: {},
      // 当前节点
      presentNode: {},
      // 文件夹的操作信息
      editFolder: {
        show: false,
        name: '',
        parentId: '',
        id: '',
        type: 0 // 0创建 1编辑
      },
      // 文件的操作信息
      editMedia: {
        show: false
      },
      // 搜索信息
      searchFileParam: {
        condition: '',
        IsSearch: 0
      },
      showFileAll: false,
      show: false,
      // 搜索到的列表
      searchFileList: [],
      // 搜索列表显示配置
      searchListProps: {
        label: 'name',
        children: 'sonFileInfo'
      },
      // 上传视频
      // uploadVideo: {
      //   show: false,
      //   session: Outil.getSession()
      // },
      pageMark: '',
      driveId: ''
    }
  },
  // components: {
  //   EditMedia,
  //   AddEditFolder,
  //   UploadVideo
  // },
  watch: {
    // 刷新第一层节点
    renderNode (item) {
      this.$nextTick(() => {
        this.presentNode = {
          id: this.NodeHeadId
        }
        this.ClearParentMap()
        this.operationSuccess()
      })
    },
    'searchFileParam.condition': {
      handler (node) {
        this.$emit('mediaInput', node)
      },
      deep: true
    }
  },
  created () {
    this.bucket = this.$BehaviorSyns.getRegionBucket('bucket')
  },
  mounted () {
    document.addEventListener('click', this.clickOthers)
    this.getCurrentPage()
  },
  methods: {
    // 监听其他地方
    clickOthers (e) {
      const thisClassName = e.target.className
      if (thisClassName != 'FileTreeScroll') {
        this.showFileAll = false
        this.show = false
      }
    },
    stopClose () {
      this.showFileAll = false
      this.show = false
    },
    showFile () {
      this.showFileAll = !this.showFileAll
      this.show = false
    },
    // 获取当前页面
    getCurrentPage () {
      this.pageMark = window.location.hash.split('#')[1]
    },
    // 刷新文件列表
    RefreshList () {
      if (this.pageMark === '/po') {
        scheduleAnalyze('schedulerFileTreeHeaderRefreshList', '/po')
      }
      if (this.pageMark === '/pop') {
        playoutAnalyze('playoutFileTreeHeaderRefreshList', '/pop')
      }
      if (this.searchFileParam.IsSearch) {
        this.getSearchFile()
      } else {
        if (!this.RefreshSwitch) return
        this.RefreshSwitch = false
        this.presentNode = {
          id: this.NodeHeadId
        }
        this.ClearParentMap()
        this.operationSuccess()
      }
    },
    // 文件的title加更新时间
    TitleAndUpdate (data) {
      let update = ''
      if (typeof data.data.updateTime == 'number') {
        update = this.transitionHourly(new Date(data.data.updateTime * 1000))
        return data.label + ' UpdateTime: ' + update
      }
      return data.label
    },
    transitionHourly (time) {
      if (time) {
        let type = ''
        const date = Outil.changeNewDate(time.getTime())
        let hour = time.getHours()
        let min = time.getMinutes()
        let s = time.getSeconds()
        const TimeFormat = Outil.getDateTimeFormat()
        if (TimeFormat.broadcastTimeFormat) {
          hour = hour >= 0 && hour < 10 ? `0${hour}` : hour
        } else {
          if (hour >= 0 && hour <= 11) {
            type = 'AM'
            hour = hour == 0 ? 12 : hour
          } else {
            type = 'PM'
            hour = hour == 12 ? hour : hour - 12
          }
        }
        min = min >= 0 && min < 10 ? `0${min}` : min
        s = s >= 0 && s < 10 ? `0${s}` : s
        return `${date} ${hour}:${min}:${s} ${type}`
      }
    },
    // 懒加载节点内容
    loadNode (node, resolve) {
      // 存储所有点开的父级节点
      this.parentMap[node.id] = {
        node,
        resolve
      }
      // 一级节点处理
      if (node.level === 0) {
        this.NodeHeadId = node.id
        this.getNodeContent(0, resolve)
      }
      // 其余节点的处理
      if (node.level >= 1) {
        this.getNodeContent(node, resolve)
      }
    },
    // 让:load=loadNode 重复触发  动态更新tree
    requestNewData (presentNode) {
      this.$set(presentNode.node, 'childNodes', []) // 把存起来的node的子节点清空，不然会界面会出现重复树！);
      this.loadNode(presentNode.node, presentNode.resolve) // 再次执行懒加载的方法
    },
    // 获取节点内容
    getNodeContent (data, resolve) {
      let param
      if (data) {
        param = {
          parentId: data.data.id,
          objectKey: data.data.objectKey,
          bucketCode: this.bucket,
          allS3: false,
          fileFrom: data.data.fileFrom
        }
      } else {
        param = {
          parentId: 0,
          bucketCode: this.bucket,
          allS3: true
        }
      }

      this.axios.post(
        '/gatewayPlayoutUrl/tvu-playout/playoutfolderNew/getFolderAndMedias',
        param,
        {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      )
        .then((res) => {
          if (param.parentId == 0) this.RefreshSwitch = true
          if (res.data.errorCode == '0x0') {
            let FileList = res.data.result
            if (param.parentId == 0) {
              this.driveId = FileList && FileList.length > 0 && FileList[0].driveId
              FileList = res.data.result
              // FileList = this.FilterFolder(res.data.result)
            }
            // 去除不应该显示的文件
            const filterList = FileList.filter((item) => item.visible)
            if (filterList.length > 0) {
              resolve(filterList)
            } else {
              resolve([
                {
                  noData: true,
                  directory: true
                }
              ])
            }

            this.$nextTick(() => {
              Bus.$emit('leftListUpdate')
            })
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) ||
              res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch(() => {
          if (param.parentId == 0) this.RefreshSwitch = true
        })
    },
    // 过滤文件夹
    FilterFolder (folderList) {
      let FileList = []
      const ProgramRMessage = Outil.getProgramReceiver()
      let showFolders
      if (ProgramRMessage) {
        showFolders = ProgramRMessage.showFolders
      }
      if (showFolders) {
        showFolders = showFolders.toUpperCase()
        const folderNameList = showFolders.split(',')
        // 筛选要显示的文件夹
        FileList = folderList.filter((item) => folderNameList.includes(item.name.toUpperCase()))
        return FileList
      }
      const { urlInfo } = JSON.parse(localStorage.getItem('channelInitConfig'))
      if (urlInfo.folderNameList) {
        const folderName = urlInfo.folderNameList.toUpperCase()
        const folderNameList = folderName.split(',')
        // 筛选要显示的文件夹
        FileList = folderList.filter((item) => folderNameList.includes(item.name.toUpperCase()))
      }
      return FileList
    },
    // 搜索显示
    searchShow () {
      if (this.pageMark === '/po') {
        scheduleAnalyze('schedulerFileTreeHeaderSearchShow', '/po')
      }
      if (this.pageMark === '/pop') {
        playoutAnalyze('playoutFileTreeHeaderSearchShow', '/pop')
      }
      // this.fileInput = !this.fileInput
      this.searchFileParam.condition = ''
      if (this.searchFileParam.IsSearch) {
        this.presentNode = {
          id: this.NodeHeadId
        }
        this.ClearParentMap()
        this.operationSuccess()
      }
      this.searchFileParam.IsSearch = 0
    },
    // 清除节点
    ClearParentMap () {
      const FirstNode = this.parentMap[this.NodeHeadId]
      this.parentMap = {}
      this.parentMap[this.NodeHeadId] = FirstNode
    },
    // 搜索文件
    async getSearchFile () {
      componentsAnalyze('publicFileTreeGetSearchFile', '/ponent')
      this.searchFileParam.IsSearch++
      await this.axios
        .post(
          '/gatewayPlayoutUrl/tvu-playout/playoutfolderNew/getFolderAndMediasByCondition',
          {
            condition: this.searchFileParam.condition,
            parentId: 0,
            bucketCode: this.bucket
          },
          {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        )
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            const FileList = res.data.result
            // const FileList = this.FilterFolder(res.data.result)
            // 去除不应该显示的文件
            const filterList = FileList.filter((item) => item.visible)
            this.searchFileList = filterList
            if (this.searchFileList.length > 0) {
              this.show = true
              this.showFileAll = false
            }
            this.$nextTick(() => {
              Bus.$emit('leftListUpdate')
            })
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) ||
              res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch(() => {})
    },
    // 获取录制文件信息
    getRecordMessage (file) {
      this.axios
        .post(
          '/gatewayPlayoutUrl/tvu-playout/record/search/info',
          {
            name: file.name
          },
          {
            contentType: 'application/json;charset=UTF-8'
          }
        )
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.SearchEditing(res.data.result)
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) ||
              res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch(() => {})
    },
    // 引入TVUSearch
    SearchEditing (file) {
      const session = Outil.getSession()
      const { urlInfo } = JSON.parse(localStorage.getItem('channelInitConfig'))
      const RegionBucket = this.$BehaviorSyns.getRegionBucket()
      const url = urlInfo.tvuSearchUrl
      const destinationFolder = file.fileEditOutputPath ? file.fileEditOutputPath : this.driveId + '/RECORDINGS/EDIT'
      const data = {
        session: session,
        mediaBucketType: 'S3',	// fixed for now
        mediaBucketName: file.data.storage.bucket,
        mediaBucketRegion: file.data.storage.region,
        mediaFilePath: file.data.storage.path,
        mediaStartTimestamp: file.beginTimestamp,
        destinationBucketName: RegionBucket.bucket,
        destinationBucketRegion: RegionBucket.region,
        destinationFolder: destinationFolder,
        fileNamePrefix: '',
        fileType: 'json'
      }
      console.log(data)
      const input = {
        version: '1.0',
        messageType: 'mark',
        origin: 'playout',
        data: data
      }
      searchIframe({
        open: () => [session, url, input],
        event: (e) => {
          console.log(e)
          this.operationSuccess('compile')
        },
        error: (e) => {
          console.log(e)
        },
        close: () => {
          console.log('close close ')
        }
      })
    },
    // 对文件夹进行操作
    changeFolder (type, node) {
      if (this.CloneDisabled.Media) return
      if (this.pageMark === '/po') {
        scheduleAnalyze('schedulerFileTreeAddFolder', '/po')
      }
      if (this.pageMark === '/pop') {
        playoutAnalyze('playoutFileTreeAddFolder', '/pop')
      }
      const urlInfo = JSON.parse(localStorage.getItem('channelInitConfig')).urlInfo
      this.editFolder = {
        show: true,
        name: '',
        parentId: node.data.id,
        id: '',
        type: 0
      }
      // 新增文件夹存当前节点
      this.presentNode = node
    },
    // 文件和文件夹操作成功
    async operationSuccess (fileType, FolderMessage) {
      // 新建最外层文件夹
      if (fileType == 'Folder' && !this.editFolder.type && this.editFolder.parentId == 0) {
        await this.NewFolder()
      }
      // fileType文件操作类型 add,compile,delete 文件操作  Folder文件夹
      // 是否事搜索的文件操作
      if (this.searchFileParam.IsSearch) {
        this.getSearchFile()
      } else {
        // 文件移动到其他文件夹
        if (fileType === 'compile' || (fileType == 'Folder' && !this.editFolder.type)) {
          this.presentNode = {
            id: this.NodeHeadId
          }
        } else if (fileType === 'add') {
          this.AddNoRefresh(FolderMessage.Folder)
        }
        const getNode = this.parentMap[this.presentNode.id]
        // 文件删除
        if (fileType === 'delete') {
          getNode.node.data.mediaCount--
          this.FileNumber(getNode)
        }
        if (fileType === 'add' && !this.presentNode.key) {
          return
        } else if (fileType === 'add' && this.presentNode.key) {
          getNode.node.data.mediaCount += FolderMessage.UploadNumber
          this.FileNumber(getNode, 'add', FolderMessage.UploadNumber)
        }
        if (getNode) {
          this.requestNewData(getNode)
        }
      }
    },
    // 新增文件不全部刷新
    AddNoRefresh (folderId) {
      for (const key in this.parentMap) {
        const item = this.parentMap[key]
        if (item.node.data && item.node.data.id == folderId) {
          this.presentNode = {
            id: key,
            key: true
          }
        }
      }
    },
    // 文件数量变化
    FileNumber (getNode, Type, Number) {
      if (getNode.node.parent) {
        const CurrentNode = this.parentMap[getNode.node.parent.id]
        if (CurrentNode.node.data) {
          if (Type == 'add') {
            if (Number) {
              CurrentNode.node.data.mediaCount += Number
            } else {
              CurrentNode.node.data.mediaCount++
            }
          } else {
            CurrentNode.node.data.mediaCount && CurrentNode.node.data.mediaCount--
          }
        }
        this.FileNumber(CurrentNode, Type, Number)
      }
    },
    // 新建文件夹
    async NewFolder () {
      const ProgramId = this.$BehaviorSyns.getProgramId()
      await this.axios
        .post(
          '/gatewayPlayoutUrl/tvu-playout/program/getProgram',
          {
            programId: ProgramId
          },
          {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        )
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            if (res.data.result) {
              const ProgramRMessage = Outil.getProgramReceiver()
              if (ProgramRMessage && res.data.result.showFolders) {
                ProgramRMessage.showFolders = res.data.result.showFolders
                sessionStorage.setItem('ProgramRMessage', JSON.stringify(ProgramRMessage))
              }
            }
          }
        }).catch(() => {})
    },
    // 点击文件预览视频
    getCurrentNode (data, node) {
      if (data.url) {
        componentsAnalyze('publicFileTreeGetCurrentNode', '/ponent')
        const suffix = Outil.FileNameSuffix(data.url)
        if (suffix == 'json' || suffix == 'mp4') {
          this.$emit('SetPreviewVideo', data, 'Media')
        } else {
          const objSourceR = {}
          objSourceR.sourceData = data
          objSourceR.type = 'ext'
          this.$emit('SetPreviewVideo', data, 'ext')
          Bus.$emit('palySourceVideo', objSourceR)
        }
      }
    },
    // 新增文件夹
    showAddFolder () {
      if (this.CloneDisabled.Media) return
      if (this.pageMark === '/po') {
        scheduleAnalyze('schedulerFileTreeHeaderAddFolder', '/po')
      }
      if (this.pageMark === '/pop') {
        playoutAnalyze('playoutFileTreeHeaderAddFolder', '/pop')
      }
      this.editFolder = {
        show: true,
        name: '',
        parentId: '0',
        id: '',
        type: 0
      }
    },
    // 上传视频
    // showUploadVideo () {
    //   if (this.CloneDisabled.Media) return
    //   if (this.pageMark === '/po') {
    //     scheduleAnalyze('schedulerFileTreeHeaderUploadVideoFile', '/po')
    //   }
    //   if (this.pageMark === '/pop') {
    //     playoutAnalyze('playoutFileTreeHeaderUploadVideoFile', '/pop')
    //   }
    //   this.uploadVideo.show = true
    // },
    // 删除文件夹
    deleteFolder (node) {
      if (this.CloneDisabled.Media) return
      if (this.pageMark === '/po') {
        scheduleAnalyze('schedulerFileTreeDeleteFolder', '/po')
      }
      if (this.pageMark === '/pop') {
        playoutAnalyze('playoutFileTreeDeleteFolder', '/pop')
      }
      this.$confirm(this.$t('lang.deleteFolder'), '', {
        confirmButtonText: this.$t('lang.Confirm'),
        cancelButtonText: this.$t('lang.cancel'),
        type: ''
      }).then(() => {
        // 编辑文件夹存父级节点
        this.presentNode = node.parent
        this.axios
          .post(
            '/gatewayPlayoutUrl/tvu-playout/playoutfolderNew/deleteFolder',
            {
              id: node.data.id,
              bucketCode: this.bucket,
              sessionId: Outil.getSession()
            },
            {
              contentType: 'application/json;charset=UTF-8'
            }
          )
          .then((res) => {
            if (res.data.errorCode == '0x0') {
              this.$message({
                type: 'success',
                message: this.$t('lang.success')
              })
              this.operationSuccess()
            } else {
              const errorInfo =
                this.$t(toTips[res.data.errorCode]) ||
                res.data.errorInfo
              this.$message.info(errorInfo)
            }
          }).catch(() => {})
      }).catch(() => {})
    },
    // 删除文件
    deleteFile (node) {
      if (this.CloneDisabled.Media) return
      if (this.pageMark === '/po') {
        scheduleAnalyze('schedulerFileTreeDeleteFile', '/po')
      }
      if (this.pageMark === '/pop') {
        playoutAnalyze('playoutFileTreeDeleteFile', '/pop')
      }
      this.$confirm(this.$t('lang.deleteMediaList'), '', {
        confirmButtonText: this.$t('lang.Confirm'),
        cancelButtonText: this.$t('lang.cancel'),
        type: ''
      }).then(() => {
        // 不是搜索的文件进行编辑
        if (!this.searchFileParam.IsSearch) {
          // 编辑文件存父级节点
          this.presentNode = node.parent
        }
        const ProgramId = this.$BehaviorSyns.getProgramId()
        this.axios
          .post(
            '/gatewayPlayoutUrl/tvu-playout/fileInfoNew/schedule/event/exist/check',
            {
              fileId: node.data.id,
              programId: ProgramId
            },
            {
              contentType: 'application/json;charset=UTF-8'
            }
          )
          .then((res) => {
            if (res.data.errorCode == '0x0') {
              // 判断是否可以直接删除
              if (res.data.result != null) {
                this.$confirm(`Clip ${res.data.result.nickName} is used in an active schedule item.   Are you sure that you want to delete it?`, '', {
                  confirmButtonText: this.$t('lang.Confirm'),
                  cancelButtonText: this.$t('lang.cancel'),
                  type: ''
                }).then(() => {
                  this.AgainDeleteFile(node, 'UpdateEvent')
                }).catch(() => {})
              } else {
                this.AgainDeleteFile(node)
              }
            } else {
              const errorInfo =
                this.$t(toTips[res.data.errorCode]) ||
                res.data.errorInfo
              this.$message.info(errorInfo)
            }
          }).catch(() => {})
      }).catch(() => { })
    },
    // 再一次删除文件
    AgainDeleteFile (node, update) {
      const ProgramId = this.$BehaviorSyns.getProgramId()
      this.axios
        .post(
          '/gatewayPlayoutUrl/tvu-playout/fileInfoNew/file/delete',
          {
            fileId: node.data.id,
            programId: ProgramId
          },
          {
            contentType: 'application/json;charset=UTF-8'
          }
        )
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.$message({
              type: 'success',
              message: this.$t('lang.success')
            })
            if (update == 'UpdateEvent') {
              // 通过websocket通知更新event
              this.$BehaviorSyns.SendBehavior('EventListChange', 1)
            }
            this.operationSuccess('delete')
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) ||
              res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch(() => {})
    },
    formatSeconds (i, name) {
      return Outil.changgeformatSeconds(i, name)
    },
    selectFile (node) {
      console.log(node)
      if (node.isLeaf) {
        this.searchFileParam.condition = node.data.name
        this.showFileAll = false
        this.show = false
        this.$emit('getSearchData', node.data)
      }
    }
  },
  beforeDestroy () {
    document.removeEventListener('click', this.clickOthers)
  }
}
</script>

<style scoped lang="less">
.PublicFileTree {
  position: relative;
  i {
    color: #cccccc;
  }
  .FileTreeTop {
    .searchTitle {
      padding: 12px 0 10px 0;
      border-bottom: 2px solid #555;
      text-align: right;
      i {
        margin: 0 4px;
        color: #cccccc;
      }
      .icon-refresh{
        font-size: 17px;
      }
    }
    .searchInput {
      position: relative;
     ::v-deep.el-input__inner{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      i {
        position: absolute;
        right: 11px;
        font-size: 14px;
        top: 13px;
        line-height: 100%;
        z-index: 1001;
        color: #fff;
        cursor: pointer;
        transition: transform .3s;
      }
      .icon-arrow-caret{
       transform: rotateZ(180deg);
      }
      .icon-arrow-reverse{
        transform: rotateZ(0deg);
      }
    }
  }
  .FileTreeScroll {
    // height: 470px;
    height: 200px;
    // max-height: 300px;
    overflow-y: auto;
    width: 100%;
    z-index: 1200;
    position: absolute;
    background-color: #444444;
    border-radius: 5px;
    box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.5);
  }
  .FileTreeScroll::-webkit-scrollbar:horizontal {
    display: none;
  }
  .draggable_box {
    margin-top: 5px;
    ::v-deep .el-tree {
      .el-tree-node__content {
        height: 32px;
        padding-left: 0 !important;
        .el-icon-caret-right:before {
          font-size: 16px;
        }
        .el-icon-loading {
          display: none;
        }
      }
      .TreeWrap {
        // width: 90%;
        width: calc(100% - 28px);
        .folderItem,
        .draggable_item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 32px;
          .fileTitle {
            width: 60%;
            font-size: 12px;
            color: #cccccc;
            text-align: left;
            overflow: hidden;
            margin: 0;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .folderOperation {
            width: 40%;
            padding-right: 6px;
            text-align: right;
            i {
              font-size: 16px;
              margin-right: 6px;
            }
          }
           .FileTime {
             width: 40%;
              font-size: 12px;
              color: #cccccc;
              line-height: 14px;
              display: block;
              text-align: right;
            }
          .fileOperation {
            width: 40%;
            .IconWrap {
              display: none;
              text-align: right;
              padding-right: 6px;
              i {
                font-size: 16px;
                margin-right: 6px;
              }
            }
            .FileTime {
              font-size: 12px;
              color: #cccccc;
              line-height: 14px;
              display: block;
              text-align: right;
            }
            // .FileTimeOld {
            //     font-size: 12px;
            //     color: #cccccc;
            //     line-height: 14px;
            //     display: block;
            // }
          }
        }
        .folderItem:hover .folderOperation {
          // display: block;
        }
        .draggable_item:hover .fileOperation {
          .IconWrap {
            display: block;
          }
          .FileTime {
            display: none;
          }
        }
      }
    }
  }
}
</style>
